(() => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
  }

  document.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls') || '');
      if (!panel) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    });
  });

  document.querySelectorAll('[data-filter-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      if (form) form.requestSubmit();
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const variantsNode = form?.querySelector('[data-variant-data]');
      const idField = form?.querySelector('[name="id"]');
      if (!variantsNode || !idField) return;
      const variants = JSON.parse(variantsNode.textContent || '[]');
      const chosen = Array.from(form.querySelectorAll('[data-variant-select]')).map((field) => field.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === chosen[index]));
      if (!variant) return;
      idField.value = variant.id;
      const price = form.closest('.product-info')?.querySelector('[data-variant-price]');
      const comparePrice = form.closest('.product-info')?.querySelector('[data-compare-at-price]');
      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.hidden = !variant.compareAtPrice;
        if (variant.compareAtPrice) comparePrice.textContent = variant.compareAtPrice;
      }
      const submit = form.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });

  const savedProductsKey = 'glow-studio-saved-products';
  let savedProducts = [];
  try {
    savedProducts = JSON.parse(localStorage.getItem(savedProductsKey) || '[]');
    if (!Array.isArray(savedProducts)) savedProducts = [];
  } catch {
    savedProducts = [];
  }

  document.querySelectorAll('[data-save-product]').forEach((button) => {
    const handle = button.dataset.saveProduct;
    const setState = (saved) => {
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? 'Remove this product from saved items' : 'Save this product for later');
    };
    setState(savedProducts.includes(handle));
    button.addEventListener('click', () => {
      const saved = button.getAttribute('aria-pressed') === 'true';
      savedProducts = saved
        ? savedProducts.filter((item) => item !== handle)
        : [...savedProducts, handle];
      try {
        localStorage.setItem(savedProductsKey, JSON.stringify(savedProducts));
      } catch {}
      setState(!saved);
    });
  });

  document.querySelectorAll('[data-accordion-trigger]').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const panel = document.getElementById(button.getAttribute('aria-controls') || '');
      if (panel) panel.hidden = expanded;
    });
  });
})();
